:host {
  // we make the host relative, so items can consistently compute their offsetTop based on the group
  @apply block relative;
}

.container {
  @apply text-start;
}

.dropdown-title {
  @apply border-color-3
  text-color-2
  -mb-px
  block
  cursor-default
  break-words
  border-0
  border-b
  border-solid
  font-bold;
}

.dropdown-separator {
  @apply block h-px;
  background-color: theme("borderColor.color.3");
}

:host([scale="s"]) {
  @apply text-n2h;
  .dropdown-title {
    @apply p-2;
  }
}

:host([scale="m"]) {
  @apply text-n1h;
  .dropdown-title {
    @apply p-3;
  }
}

:host([scale="l"]) {
  @apply text-0h;
  .dropdown-title {
    @apply p-4;
  }
}

@include base-component();
